export const OUTWARD_SUPPLIES_HEADERS: any[] = [
  {
    label: "",
    value: "",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "INVOICE DATE",
    value: "invoice_date",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "CUSTOMER NAME & GST",
    value: "customer_name_gst",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "INVOICE NUMBER",
    value: "invoice_number",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "DOCUMENT TYPE",
    value: "document_type",
    defaultChecked: true,
    checked: true,
  },

  {
    label: "MONTH IN GSTR 3B",
    value: "table_no_of_gstr3b",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "MONTH IN GSTR 1",
    value: "table_no_of_gstr1",
    defaultChecked: true,
    checked: true,
  },

  {
    label: "EXPORTS",
    value: "exports",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "EXPORTS TAX PMT",
    value: "exports_tax_payment",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "SEZ",
    value: "sez",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "SEZ TAX PMT",
    value: "sez_tax_payment",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "SALES TYPE",
    value: "sales_type",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "PLACE OF SUPPLY",
    value: "pos",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "TOTAL IGST ",
    value: "total_igst_amount",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "TOTAL SGST",
    value: "total_sgst_amount",
    defaultChecked: true,
    checked: true,
  },

  {
    label: "TOTAL CGST",
    value: "total_cgst_amount",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "TOTAL TAXABLE",
    value: "total_taxable_value",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "TOTAL INVOICE",
    value: "total_invoice_value",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "TABLE & CATEGORY",
    value: "gst_exemption",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "REVERSE CHARGE",
    value: "reverse_charge",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "GSTR1 Type",
    value: "gstr1_type",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "GSTR3B Type",
    value: "gstr3b_type_arr",
    defaultChecked: true,
    checked: true,
  },

  //commented for future use
  // {
  //     "label": "COMPOSITION DEALER SUPPLY",
  //     "value": "supply_to_composition_on_dealer",
  //     "defaultChecked": true,
  //     "checked": true
  // },

  // {
  //     "label": "APPROVAL",
  //     "value": "approval",
  //     "defaultChecked": true,
  //     "checked": true
  // }
];

export const ITEM_TABLE_HEADERS: any[] = [
  {
    label: "NATURE OF INCOME",
    value: "nature_of_income",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "NATURE OF EXPENSE",
    value: "nature_of_expense",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "DESC AS PER BILL",
    value: "desc_as_per_bill",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "SKU CODE",
    value: "sku_code",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "HSN/SAC CODE",
    value: "hsn_sac_code",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "UNIT",
    value: "unit",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "RATE",
    value: "rate",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "QUANTITY",
    value: "quantity",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "AMOUNT",
    value: "amount",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "DISCOUNT",
    value: "discount",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "TAXABLE VALUE",
    value: "taxable_value",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "GST PERCENTAGE",
    value: "gst_per",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "IGST AMOUNT",
    value: "igst_amount",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "SGST AMOUNT",
    value: "sgst_amount",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "CGST AMOUNT",
    value: "cgst_amount",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "TOTAL VALUE",
    value: "total_value",
    defaultChecked: true,
    checked: true,
  },
];
